<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="6"
                    md="5"
                    lg="3"
            >
                <v-card class="elevation-12">
                    <v-card-text>
                        <v-container class="pb-0">
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                  <div style="height: 0.5rem;">
                                    <v-progress-linear
                                        v-show="loading"
                                        height="8"
                                        indeterminate
                                        color="primary"
                                    ></v-progress-linear>
                                  </div>
                                </v-col>
                            </v-row>
                            <v-row>

                                <v-col cols="12" sm="12" md="12">
                                  {{ $t('trialLanding.text') }}
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
        name: 'TrialLandingPage',
        data: () => ({
            error: null,
            success: null,
            loading: true,
        }),
        computed: {},
        created() {
           const token = this.$route.query.token;
            if(typeof token !== 'undefined') {
              this.$store.dispatch('loginWithToken', {token}).then((responseData) => {
                if(responseData.success === true && responseData.result !== false && responseData.result.user) {
                  this.forwardToSharesuite();
                }
              });
            }
        },
        methods: {
            forwardToSharesuite() {
                let forwardHash = location.hash.substr(location.hash.lastIndexOf("#")).replace("#/login", "");
                let host = location.protocol + "//" + location.hostname + (!location.hostname.endsWith("/") ? "/" : "");
                location.replace(host + process.env.VUE_APP_WEB_APP_PATH + '?' + forwardHash);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-button {
        width: 100%;
        text-transform: initial;
    }

    .v-card__text {
        padding-bottom: 0 !important;
    }

    .header-image-container {
        height: 75px;
    }
</style>
